import { render, staticRenderFns } from "./publicBack.vue?vue&type=template&id=f87cd5ae&scoped=true"
import script from "./publicBack.vue?vue&type=script&lang=js"
export * from "./publicBack.vue?vue&type=script&lang=js"
import style0 from "./publicBack.vue?vue&type=style&index=0&id=f87cd5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87cd5ae",
  null
  
)

export default component.exports